<template>

  <div>
    <div
      class="variables mb-3"
      v-if="variables.length">
      <button
        type="button"
        class="btn btn-sm btn-secondary"
        v-for="(item, index) in variables"
        :key="index"
        @click="addVariable(item)">
        {{ item }}
        </button>
    </div>

    <editor
      :init="editar_init"
      v-model="html"
      ref="tinymceEditor">
      </editor>

    <div
      v-if="showModal === 'image'"
      class="modal adapted-meet-max-width"
      tabindex="-1"
      role="dialog"
      @click.self="toggleModal">
      <div
        class="modal-dialog"
        role="document"
        :style="{'max-width': '640px'}">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('Image') }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="toggleModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            class="modal-body"
            :style="{'min-height': '100px'}">
            <input
              type="file"
              name="uploadfile"
              id="uploadfile"
              style="display: none;"
              @input="uploadFile" />
            <label
              style="cursor: pointer"
              for="uploadfile"
              class="btn btn-primary"
              v-if="!loading">Selecionar arquivo</label>
            <div
              v-if="errorSizeLimit"
              class="alert alert-warning">
              O arquivo deve ter no máximo 3,4Mb.
            </div>
            <div v-if="loading">Carregando...</div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="toggleModal">{{ $t('Cancel') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showModal === 'link'"
      class="modal adapted-meet-max-width"
      tabindex="-1"
      role="dialog"
      @click.self="toggleModal">
      <div
        class="modal-dialog"
        role="document"
        :style="{'max-width': '640px'}">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('Adicionar/Editar Link') }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="toggleModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            class="modal-body"
            :style="{'min-height': '100px'}">
            <div class="form-group">
              <label for="linkUrl">URL:</label>
              <input type="text" class="form-control" v-model="linkUrl" id="linkUrl" placeholder="https://">
            </div>
            <div class="form-group">
              <label for="linkTarget">Abrir link em:</label>
              <select class="form-control" v-model="linkTarget" id="linkTarget">
                <option value="_blank">Nova aba</option>
                <option value="_self">Mesma aba</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="toggleModal">{{ $t('Cancel') }}</button>
            <button
              type="button"
              class="btn btn-primary"
              @click="insertLink">Adicionar Link</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import 'tinymce/tinymce'  // Verifique se está importando corretamente
import 'tinymce/icons/default/icons'
import 'tinymce/themes/silver/theme'
import 'tinymce/skins/ui/oxide/skin.min.css'  // Caminho correto para o CSS da skin

// Plugins TinyMCE
import 'tinymce/plugins/lists/plugin'
import 'tinymce/plugins/link/plugin'
import 'tinymce/plugins/image/plugin'
import 'tinymce/plugins/table/plugin'
import 'tinymce/plugins/code/plugin'
import 'tinymce/plugins/help/plugin'
import 'tinymce/plugins/wordcount/plugin'
import 'tinymce/plugins/autoresize/plugin'  // Adicione o plugin corretamente
import 'tinymce/plugins/paste/plugin'  // Adicione o plugin corretamente

// import 'tinymce/skins/content/default/content.css' // Caminho correto para o CSS de conteúdo
// import 'tinymce/skins/ui/oxide/content.min.css' // Caminho correto para o CSS de conteúdo
import contentCss from '!!raw-loader!tinymce/skins/content/default/content.min.css' // eslint-disable-line
import contentUiCss from '!!raw-loader!tinymce/skins/ui/oxide/content.min.css' // eslint-disable-line

import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'TextareaEditableTinymce',
  components: {
    'editor': Editor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    variables: {
      type: Array,
      default: () => { return [] }
    },
    enableFormatselect: {
      type: Boolean,
      default: false
    },
    enableForecolor: {
      type: Boolean,
      default: false
    },
    enableLink: {
      type: Boolean,
      default: false
    },
    enableImg: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: null
    },
    bgColor: {
      type: String,
      default: '#ffffff'
    }
  },
  data () {
    const _self = this
    return {
      loading: false,
      errorSizeLimit: null,
      showModal: null,
      html: this.value,
      linkUrl: '',  // Campo para armazenar a URL
      linkTarget: '_blank',  // Campo para armazenar o target (_blank ou _self)
      editar_init: {
        skin: false,  // Desativa o carregamento automático da skin
        // content_css: false,  // Desativa o carregamento automático do CSS de conteúdo
        content_css: '/tinymce/skins/content/default/content.css',
        content_style: `
          body {
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
            font-size: 14px;
            line-height: 1.6;
            background-color: ${this.bgColor};
          }
          ${[contentCss, contentUiCss].join('\n')}
        `,
        menubar: false,
        statusbar: false,
        toolbar: [
          `${this.enableFormatselect ? 'formatselect' : ''} bold italic underline`,
          // '#alignleft #aligncenter #alignright #alignjustify',
          'bullist numlist outdent indent',
          `${this.enableForecolor ? 'forecolor' : ''} removeformat ${this.enableLink ? 'customLink' : ''} ${this.enableImg ? 'uploadImageButton' : ''}`
        ].join('|'),
        // content_css: '../lab/skins/css/tinymce-body.css?v=3',
        plugins: `autoresize, paste, link, lists`,
        autoresize_min_height: 80,
        contextmenu: false,
        autoresize_bottom_margin: 10,
        paste_as_text: true,

        // object_resizing: true,
        // image_dimensions: true,
        // image_advtab: true,
        setup (editor) {
          editor.ui.registry.addButton('uploadImageButton', {
            icon: 'image',
            tooltip: 'Upload image',
            onAction: function () {
              _self.toggleModal('image')
            }
          })
          editor.ui.registry.addButton('customLink', {
            icon: 'link',
            tooltip: 'Link',
            onAction: () => {
              const selectedNode = editor.selection.getNode() // Pega o nó selecionado
              const existingLink = selectedNode.nodeName === 'A' ? selectedNode.getAttribute('href') : ''
              const existingTarget = selectedNode.nodeName === 'A' ? selectedNode.getAttribute('target') : '_blank'
              // console.log({ existingTarget })

              // Preenche o modal com os valores atuais, se houver
              _self.linkUrl = existingLink || ''
              _self.linkTarget = existingTarget || '_blank'
              _self.toggleModal('link')
            }
          })
        }
      }
    }
  },
  watch: {
    html: function (val) {
      this.$emit('input', val)
    },
    value: function (val) {
      if (val !== this.html) this.html = val
    }
  },
  created () {
  },
  computed: {
    currentTinymceEditor () {
      // return window.tinymce.activeEditor // esse é para retronar o editar adivo na tela
      const elEditor = this.$refs.tinymceEditor
      return elEditor ? elEditor.editor : null
    }
  },
  methods: {
    addVariable (variable) {
      this.currentTinymceEditor.execCommand('mceInsertContent', false, variable)
    },
    toggleModal (type = null) {
      this.showModal = type
    },
    insertLink () {
      if (this.linkUrl) {
        const selectionContent = this.currentTinymceEditor.selection.getContent()
        const content = `<a href="${this.linkUrl}" target="${this.linkTarget}">${selectionContent}</a>`
        this.currentTinymceEditor.execCommand('mceInsertContent', false, content)
      } else {
        this.currentTinymceEditor.execCommand('unlink')
      }
      this.toggleModal() // Fecha o modal
    },
    clearLinkForm () {
      this.linkUrl = ''
      this.linkText = ''
    },
    uploadFile (event) {
      if (!(event && event.target && event.target.files && event.target.files[0])) {
        return null
      }
      const file = event.target.files[0]
      if (!['image/png', 'image/jpeg', 'image/gif'].includes(file.type)) {
        return null
      }
      const formData = new FormData()
      formData.append('file', file)

      this.loading = true
      return this.$store.dispatch('createMediaMultipart', formData).then(result => {
        const content = `<img src="${result.url}" style="max-width: 100%; height: auto;" />`
        this.currentTinymceEditor.execCommand('mceInsertContent', false, content)
        this.toggleModal()
      }).catch(err => {
        console.log(err)
        if (err.response.status === 413) {
          this.errorSizeLimit = true
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.variables{
  display: block;
  margin: -2px;
}
  .variables > *{
    margin: 2px;
  }
  .variables > *.btn-sm {
    padding: 2px 5px;
  }

.modal{
  display: block;
  background: rgb(0,0,0,0.7);
  padding: 20px;
  cursor: default;
}
  .modal-dialog {
    height: 100%;
    max-height: calc(100% - 40px);
  }
  .modal-content {
    max-height: 100%;
  }
  .modal-body {
    overflow: auto;
    max-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Fields/TextareaEditableTinymce.vue